var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-action-sheet',{model:{value:(_vm.showCityPick),callback:function ($$v) {_vm.showCityPick=$$v},expression:"showCityPick"}},[_c('div',{staticClass:"content"},[_c('van-area',{attrs:{"area-list":_vm.areaList,"value":"110101","title":"选择地区"},on:{"cancel":_vm.onCancel,"confirm":_vm.onConfirm}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }